/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import { menu } from '../scripts/menu';
import { loading } from './loading';
import { scrollButton } from './scroll-button';
import { elementorCustom } from '../scripts/elementor';
//import Swiper, { Navigation, Pagination } from 'swiper';

//Swiper.use([Navigation, Pagination]);

$(() => {
  $('.menu-item a[href*=#]').on('click', function (e) {
    e.preventDefault(); // prevent hard jump, the default behavior

    var target = $(this).attr("href"); // Set the target as variable

    // perform animated scrolling by getting top-position of target-element and set it as scroll target
    let point = $(target).offset().top;
    point = point - 80;
    $('html, body').stop().animate({
      scrollTop: point
    }, 300, function () {
      //location.hash = target; //attach the hash (#jumptarget) to the pageurl
    });

    return false;
  });

  scrollButton();
  loading();
  menu();
  elementorCustom();
});


